var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"width":"640"}},[(_vm.isMounted)?_c('StreamBarcodeReader',{attrs:{"width":"640"},on:{"decode":_vm.onDecode,"loaded":_vm.onLoaded}}):_vm._e()],1),_c('v-card')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }